export var ManualActionStatusEnum;
(function (ManualActionStatusEnum) {
    ManualActionStatusEnum["PENDING"] = "PENDING";
    ManualActionStatusEnum["REJECTED"] = "REJECTED";
    ManualActionStatusEnum["ACCEPTED"] = "ACCEPTED";
})(ManualActionStatusEnum || (ManualActionStatusEnum = {}));
//# sourceMappingURL=manual-action-status.enum.js.map